// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Orders_Payments_Types from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var GetPaymentChannelsResponse = function (x) {
    return x;
};
var GetPaymentChannelsRequest = function (x) {
    return x;
};
var eqGetPaymentChannelsRespo = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Orders_Payments_Types.eqChannelInfo))(x.channels)(y.channels);
        };
    }
};
var eqGetPaymentChannelsReque = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId);
        };
    }
};
var rpcMethodNameGetPaymentChannelsRequest = {
    rpcMethodName: function (v) {
        return "GetPaymentChannelsRequest";
    }
};
var newtypeGetPaymentChannelsResponse = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetPaymentChannelsRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetPaymentChannelsResponse = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetPaymentChannelsRequest = function (dictHasField) {
    return dictHasField;
};
var genericGetPaymentChannelsResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetPaymentChannelsResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "channels";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Payments_Types.showChannelInfo)))))({
        reflectSymbol: function () {
            return "GetPaymentChannelsResponse";
        }
    }))
};
var unscrambleDecodeGetPaymentChannelsResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "channels";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Payments_Types.unscrambleDecodeChannelInfo))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGetPaymentChannelsRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetPaymentChannelsRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Restaurant_Types_Id.showRestaurantId))))({
        reflectSymbol: function () {
            return "GetPaymentChannelsRequest";
        }
    }))
};
var unscrambleDecodeGetPaymentChannelsRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeGetPaymentChannelsResponse = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetPaymentChannelsResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "channels";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Payments_Types.encodeChannelInfo)))))))(encodingOpts)
};
var encodeGetPaymentChannelsRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetPaymentChannelsRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId))))))(encodingOpts)
};
var decodeGetPaymentChannelsResponse = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetPaymentChannelsResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "channels";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Payments_Types.decodeChannelInfo)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeGetPaymentChannelsRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetPaymentChannelsRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    GetPaymentChannelsRequest,
    GetPaymentChannelsResponse,
    encodingOpts,
    genericGetPaymentChannelsRequest,
    showGetPaymentChannelsRequest,
    eqGetPaymentChannelsReque,
    decodeGetPaymentChannelsRequest,
    unscrambleDecodeGetPaymentChannelsRequest,
    encodeGetPaymentChannelsRequest,
    newtypeGetPaymentChannelsRequest,
    hasFieldGetPaymentChannelsRequest,
    rpcMethodNameGetPaymentChannelsRequest,
    genericGetPaymentChannelsResponse,
    showGetPaymentChannelsResponse,
    eqGetPaymentChannelsRespo,
    decodeGetPaymentChannelsResponse,
    unscrambleDecodeGetPaymentChannelsResponse,
    encodeGetPaymentChannelsResponse,
    newtypeGetPaymentChannelsResponse,
    hasFieldGetPaymentChannelsResponse
};
//# sourceMappingURL=index.js.map
